export var PlayerRankingCategory;
(function (PlayerRankingCategory) {
    PlayerRankingCategory[PlayerRankingCategory["PlayerLevelRanking"] = 8] = "PlayerLevelRanking";
    PlayerRankingCategory[PlayerRankingCategory["CoopLevelRanking"] = 32] = "CoopLevelRanking";
    PlayerRankingCategory[PlayerRankingCategory["AdventurerLevelRanking"] = 33] = "AdventurerLevelRanking";
})(PlayerRankingCategory || (PlayerRankingCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/PlayerRankingCategory.ts
// module id = 237
// module chunks = 3